
import Vue from 'vue'

export default Vue.extend({
    props: {
        address: String
    },
    computed: {
        link(): string {
            return `https://vechainstats.com/account/${this.address}/`
        },
        iconURL(): string {
            return require('../assets/vechainstats-logo.png')
        }
    }
})
